import type { DefaultResponseList } from "@schemas/common";
import type { RequestGetMaps, ResponseGetMaps } from "@schemas/maps";

import instance from "@utils/axiosInstance";
import { useCreateQuery, type QueryOpts } from "@utils/generateReactQuery";

const BASE_URL = "/maps";

const API = {
	getMaps: async (params: RequestGetMaps) => await instance.get(BASE_URL, { params }),
	getAllMaps: async (query: string) => await instance.get(BASE_URL, { params: { query } }),
};

const KEY = {
	getMaps: (params: RequestGetMaps) => ["/maps", params],
	getAllMaps: (query: string) => ["/maps", query],
};

export function useGetMaps(
	params: RequestGetMaps,
	options?: QueryOpts<DefaultResponseList<ResponseGetMaps>>,
) {
	return useCreateQuery<DefaultResponseList<ResponseGetMaps>>(
		KEY.getMaps(params),
		() => API.getMaps(params),
		{
			...options,
		},
	);
}

export function useGetAllMaps(
	query: string,
	options?: QueryOpts<DefaultResponseList<ResponseGetMaps>>,
) {
	return useCreateQuery<DefaultResponseList<ResponseGetMaps>>(
		KEY.getAllMaps(query),
		() => API.getAllMaps(query),
		{
			...options,
		},
	);
}
